import type { AuthTokens } from "../types/auth";

export const SESSION_KEY = "kkp_admin_session_v1";

function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

export function isSessionValid(
  tokens: AuthTokens | null | undefined,
): tokens is AuthTokens {
  return Boolean(
    tokens &&
    isNonEmptyString(tokens.access) &&
    isNonEmptyString(tokens.refresh),
  );
}

export function readSession(): AuthTokens | null {
  try {
    const raw = window.localStorage.getItem(SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as
      | Partial<AuthTokens>
      | { tokens?: Partial<AuthTokens> }
      | null;

    const tokens = (parsed as any)?.tokens ?? parsed;

    if (!tokens || !isSessionValid(tokens as AuthTokens)) {
      window.localStorage.removeItem(SESSION_KEY);
      return null;
    }

    return { access: (tokens as AuthTokens).access, refresh: (tokens as AuthTokens).refresh };
  } catch {
    try {
      window.localStorage.removeItem(SESSION_KEY);
    } catch {
      // ignore
    }
    return null;
  }
}

export function writeSession(tokens: AuthTokens): void {
  if (!isSessionValid(tokens)) {
    throw new Error("Invalid session tokens");
  }
  try {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(tokens));
  } catch {
    // ignore storage errors (private mode, quotas, etc.)
  }
}

export function clearSession(): void {
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore storage errors
  }
}
